import instance from "../utils/instance";

class SupplierService {
    async getImportConfirmData(batchId) {
		return await instance.get('/crm/supplier/getImportCache?key=' + batchId);
    }

    async submitImportConfirmData(data,batchId) {
		return await instance.post('/crm/supplier/updateImportCache',{
			cacheKey:batchId,
			supplierDataJson:data
		});
    }
}

export default new SupplierService();